import React, { useContext, useEffect, useState } from "react"

import CommonContext from "@src/context"
import classNames from "@utils/classnames"
import names from "./ssb-names"

import Section from "@components/section"
import Clickable from "@components/clickable"
import ClickableImage from "@components/clickableImage"
import BottomButtons from "@components/bottomButtons"
import Button from "@components/button"
import Tabs from "@components/tabs"
import Modal from "react-modal"

import bgImage from "@images/ssb-bg.jpg"
import matchImg from "@images/season1/ssb-duizhen.png"
import day1Img from "@images/season1/ssb-day1.png"
import day2Img from "@images/season1/ssb-day2.png"
import day3Img from "@images/season1/ssb-day3.png"
import day4Img from "@images/season1/ssb-day4.png"
import dayFinalImg from "@images/season1/ssb-day-final.png"

const SuperSmashBros = () => {
  const { setBg } = useContext(CommonContext)
  const [nameListVisible, setNameListVisible] = useState(false)
  useEffect(() => {
    setBg(bgImage)
  }, [])
  return (
    <div>
      <Modal
        isOpen={nameListVisible}
        overlayClassName="modalOverlay"
        className="modal"
        onRequestClose={() => {
          setNameListVisible(false)
        }}
      >
        <div className={classNames("box box-white")}>
          <div
            className="enrollModal"
            style={{ width: "600px", maxWidth: "100%" }}
          >
            <p>参赛选手剩余名单</p>
            <div>
              {names.map((name, i) => {
                return (
                  <span key={name}>
                    <span>{name}</span>
                    {i !== names.length - 1 && "、"}
                  </span>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>
      <Section title="比赛回顾">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>SEASON 1 冠军 </td>
              <td>汉尼拔</td>
            </tr>
            <tr>
              <td>A组冠军</td>
              <td>XIFL</td>
            </tr>
            <tr>
              <td>B组冠军</td>
              <td>汉尼拔</td>
            </tr>
            <tr>
              <td>C组冠军</td>
              <td>bushihunzi</td>
            </tr>
            <tr>
              <td>D组冠军</td>
              <td>Mithril</td>
            </tr>
            <tr>
              <td>晋级选手</td>
              <td>
                XIFL
                <br />
                xxy
                <br />
                Doomblaze
                <br />
                汉尼拔
                <br />
                Ma
                <br />
                Spike
                <br />
                bushihunzi
                <br />
                Pusheen
                <br />
                Herr Oberst Nu
                <br />
                Mithril
                <br />
                xPx
                <br />
                MNM
                <br />
                GG7
              </td>
            </tr>
            <tr>
              <td>其他参赛选手</td>
              <td>
                <Clickable
                  onClick={() => {
                    setNameListVisible(true)
                  }}
                >
                  展示全部
                </Clickable>
              </td>
            </tr>
          </tbody>
        </table>
        <Tabs
          tabs={[
            { key: "1", title: "GROUP A" },
            { key: "2", title: "GROUP B" },
            { key: "3", title: "GROUP C" },
            { key: "4", title: "GROUP D" },
            { key: "final", title: "FINAL STAGE" },
          ]}
        >
          {active => {
            let imgPath = null
            if (active === "1") {
              imgPath = day1Img
            } else if (active === "2") {
              imgPath = day2Img
            } else if (active === "3") {
              imgPath = day3Img
            } else if (active === "4") {
              imgPath = day4Img
            } else if (active === "final") {
              imgPath = dayFinalImg
            }
            return (
              imgPath && <ClickableImage className="fluidImage" src={imgPath} />
            )
          }}
        </Tabs>
        <div className="buttonsContainer">
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV14541147RK?p=1"
          >
            A组视频录像
          </Button>
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV1z5411479W?p=1"
          >
            B组视频录像
          </Button>
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV1ET4y137pz?p=1"
          >
            C组视频录像
          </Button>
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV1Lf4y1m7bm?p=1"
          >
            D组视频录像
          </Button>
          <Button
            color="blue"
            href="https://www.bilibili.com/video/BV1ez411q7U9?p=1"
          >
            总决赛视频录像
          </Button>
        </div>
      </Section>
      <Section title="比赛信息">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>比赛时间</td>
              <td>
                4月30日（周四） 20 : 00 开始 A组 4强双败淘汰赛
                <br />
                5月1日（周五） 20 : 00 开始 B组 4强双败淘汰赛
                <br />
                5月2日（周六） 14 : 00 开始 C组 6强双败淘汰赛
                <br />
                5月3日（周日） 14 : 00 开始 D组 6强双败淘汰赛
                <br />
                5月10日（周日） 20: 00 开始 决赛
                <br />
                <br />（ 4月17日报名结束后开启各小组双败淘汰预选赛阶段 ）<br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  前往虎牙直播间：660161
                </a>
              </td>
            </tr>
            <tr>
              <td>模式</td>
              <td>直播线上赛</td>
            </tr>
            <tr>
              <td>赛制</td>
              <td>双败淘汰赛</td>
            </tr>
            <tr>
              <td>比赛规则</td>
              <td>
                前期对局采用BO3，决赛段采用BO5。
                <br />
                每局3条命；限时7分钟；无道具；无绝招；无命魂；
              </td>
            </tr>
            <tr>
              <td>比赛地图</td>
              <td>
                限定地图：
                <br />
                Battlefield、Final Destination、Kalos Pokémon League、Lylat
                Cruise、 Pokémon Stadium 2、Smashville、Town and City、Yoshi's
                Story
              </td>
            </tr>
            <tr>
              <td>游戏版本</td>
              <td>比赛日更新的最新版本</td>
            </tr>
            <tr>
              <td>报名流程</td>
              <td>
                1. 填写赛事报名表；2. 提交后扫码加「赛事选手官方」群；3.
                关注群内赛事安排信息
              </td>
            </tr>
            <tr>
              <td>S1资格赛奖励</td>
              <td>
                A、B、C、D组前3名可获得 SPARK 线上总决赛赛的参赛资格
                <br />
                A、B、C、D组冠军加赛一局，获胜者将额外获得 1,500 元的奖金奖励
              </td>
            </tr>
            <tr>
              <td>线上总决赛奖金</td>
              <td>
                冠军 3,000
                <br />
                亚军 1,500
                <br />
                季军 1,000
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="比赛须知">
        <div className="tips">
          <p>
            1.
            报名截止后，将由机核方统一安排赛程抽签，抽签过程为保证公平性，将会发放到选手群里进行确认。
          </p>
          <p>
            2.
            由于本次比赛为线上直播形式，参赛队伍需要保证在比赛时段内网络通畅，随时可以准备进行比赛。请在报名前确认好你的时间；
          </p>
          <p>
            3.
            如果参赛队伍迟到五分钟及以上，或因未到、提前离开等原因未参赛，则认定该队失去参赛资格，判该队对手获胜；
          </p>
          <p>
            4. 参赛选手的 ID
            、头像、队伍名称、衣物、携带物品等不得含有违法国家法律法规的、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的文字、图案以及其他元素。如出现上述禁止情况，一经查证，则将取消该队伍参赛资格与比赛成绩；
          </p>
          <p>
            5.
            参赛选手不得发表违法国家法律法规、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的言论。如出现上述禁止情况，则取消该队伍参赛资格与比赛成绩；
          </p>
          <p>6. 本次比赛，机核网拥有最终解释权。</p>
        </div>
      </Section>
      <Section title="对阵表">
        <ClickableImage className="fluidImage" src={matchImg} />
      </Section>
      <BottomButtons>
        {() => {
          return (
            <div className="enrollModal enrollModal-thinBtmPadding">
              <p>请根据个人时间选择可参加的比赛组（不可重复报名）</p>
              <div className="enrollList">
                <div className="enroll">
                  <h3>GROUP A</h3>
                  <h2>
                    4月30日
                    <br />
                    20:00
                  </h2>

                  <Button
                    color="blue"
                    href="http://sparkidea.mikecrm.com/nnzDx4u"
                  >
                    确认报名
                  </Button>
                </div>
                <div className="enroll">
                  <h3>GROUP B</h3>
                  <h2>
                    5月1日
                    <br />
                    20:00
                  </h2>

                  <Button
                    color="blue"
                    href="http://sparkidea.mikecrm.com/IC1agev"
                  >
                    确认报名
                  </Button>
                </div>
                <div className="enroll">
                  <h3>GROUP C</h3>
                  <h2>
                    5月2日
                    <br />
                    14:00
                  </h2>

                  <Button
                    color="blue"
                    href="http://sparkidea.mikecrm.com/JVAcG2w"
                  >
                    确认报名
                  </Button>
                </div>
                <div className="enroll">
                  <h3>GROUP D</h3>
                  <h2>
                    5月3日
                    <br />
                    14:00
                  </h2>

                  <Button
                    color="blue"
                    href="http://sparkidea.mikecrm.com/pSJTBXU"
                  >
                    确认报名
                  </Button>
                </div>
              </div>
            </div>
          )
        }}
      </BottomButtons>
    </div>
  )
}

export default SuperSmashBros
